export const locale = {
    lang: 'fr',
    data: {
        CATEGORIES: 'Couleurs',
        ADD: 'Ajouter',
        EDIT_CATEGORY: 'Modifier couleur',
        DELETE_CATEGORY: 'Supprimer la couleur',
        ADD_CATEGORY: 'Ajouter couleur',
        ADD_U: 'AJOUTER',
        NAME: 'Nom',
    }
};
